export default __webpack_public_path__ + "static/media/all_products.36c44873.png";